<template>
    <submenu-page
        eyebrow="SCHOOL SETUP"
        title="Academic management"
        description="Set up the school calendar, classes, subjects and assessment structure used across reports and results."
        count-label="setup tools"
    >
        <SubMenu />
    </submenu-page>
</template>

<script>
import SubMenu from "./SubMenu.vue";

export default {
    name: "AcademicManagement",
    components: {
        SubMenu
    },
    data() {
        return {
            accessDetails: null
        };
    },
    mounted() {
        this.accessDetails = this.$store.getters["auth/_user"];
        if (!this.accessDetails || this.accessDetails.isSchoolStaff == false) {
            this.$store.dispatch("auth/Logout");
            this.$router.push("/login");
        }
    }
};
</script>
